const hobbies = [
    "Continuous Learning",
    "movies and documentaries",
    "Board games/Puzzles",
    "Soccer"
]

export default hobbies;
